@if (show) {
  <app-base-edit-form
    [fields]="fields"
    [id]="salesDespatchNoteId ?? goodsDeliveryNoteId"
    [baseService]="shipperInterfaceHeaderService"
    [closeOnSave]="false"
    [updateModelOnSave]="true"
    (modelLoaded)="modelLoaded($event)"
    (saved)="saved()"
  >
  </app-base-edit-form>

  <div class="d-flex justify-content-end mt-2">
    <app-base-inline-form [fields]="buttonFields" [marginBottom]="false"></app-base-inline-form>
  </div>

  <hr />

  <app-tab-grid
    i18n-header
    header="Shipment Details"
    gridCssClass="shipper-interface-grid"
    stateKey="DespatchShipperInterfaceShipmentDetails"
    [columnDefs]="columnDefs"
    [rowData]="model?.shipperInterfaceDetails ?? []"
    [showExport]="false"
    (create)="create()"
    (edit)="editDetails($event)"
    (delete)="delete($event)"
  ></app-tab-grid>
}
